<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <h6 style="color: #101010" class="m-0 mb-2">
        {{ $l('form_label_baseInfo') || '基本信息' }}
      </h6>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_salesPerson') || '业务'"
            prop="salesPersonCode"
          >
            <dict-select
              v-model="formData.salesPersonCode"
              :selectedLabel.sync="formData.salesPersonName"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('form_placeholder_salesPerson') || '请选择业务'"
              size="mini"
              filterable
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_merchandiser') || '跟单'"
            prop="merchandiserCode"
          >
            <dict-select
              v-model="formData.merchandiserCode"
              :selectedLabel.sync="formData.merchandiserName"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('form_placeholder_merchandiser') || '请选择跟单'"
              size="mini"
              filterable
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_platform') || '渠道'"
            prop="platformCode"
          >
            <dict-select
              v-model="formData.platformCode"
              url="/ecom/evg/platform/select"
              :placeholder="$l('form_placeholder_platform') || '请选择渠道'"
              size="mini"
              filterable
              clearable
              style="width:100%"
              @change="platformChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_cust') || '所属客户'">
            <el-input v-model="formData.custName" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_custOrderNo') || '客户订单号'"
            prop="custOrderNo"
          >
            <el-input
              v-model="formData.custOrderNo"
              :placeholder="
                $l('form_placeholder_custOrderNo') || '请输入客户订单号'
              "
              :maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_orderDate') || '订单日期'"
            prop="orderDate"
          >
            <el-date-picker
              v-model="formData.orderDate"
              :placeholder="
                $l('form_placeholder_orderDate') || '请选择订单日期'
              "
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_deliveryDate') || '交货日期'"
            prop="deliveryDate"
          >
            <el-date-picker
              v-model="formData.deliveryDate"
              :placeholder="
                $l('form_placeholder_deliveryDate') || '请选择交货日期'
              "
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_beginShippingDate') || '最早发运日期'"
            prop="beginShippingDate"
          >
            <el-date-picker
              v-model="formData.beginShippingDate"
              :placeholder="
                $l('form_placeholder_beginShippingDate') || '请选择最早发运日期'
              "
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_endShippingDate') || '最晚发运日期'"
            prop="endShippingDate"
          >
            <el-date-picker
              v-model="formData.endShippingDate"
              :placeholder="
                $l('form_placeholder_endShippingDate') || '请选择最晚发运日期'
              "
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_paymentTerms') || '客户付款条件'"
            prop="paymentTerms"
          >
            <dict-select
              v-model="formData.paymentTerms"
              url="/master/common/dict/biz"
              :body="{ dictType: 'paymentTerms' }"
              :placeholder="
                $l('form_placeholder_paymentTerms') || '请选择客户付款条件'
              "
              size="mini"
              filterable
              clearable
              style="width:100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-form-item
            :label="$l('form_label_salesCurrencyUnit') || '货币单位'"
          >
            <dict-select
              v-model="formData.salesCurrencyUnit"
              url="/master/common/dict/biz"
              :body="{ dictType: 'currencyUnit' }"
              :placeholder="
                $l('form_placeholder_salesCurrencyUnit') || '请选择货币单位'
              "
              size="mini"
              disabled
              style="width:100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-form-item
            :label="$l('form_label_outBillType') || '出单类型'"
            prop="outBillType"
          >
            <dict-select
              v-model="formData.outBillType"
              url="/master/common/dict/biz"
              :body="{ dictType: 'outBillType' }"
              :placeholder="
                $l('form_placeholder_outBillType') || '请选择出单类型'
              "
              size="mini"
              filterable
              clearable
              style="width:100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_region') || '货物运抵国'">
            <dict-select
              v-model="formData.regionCode"
              :selectedLabel.sync="formData.regionName"
              url="/master/common/dict/biz"
              :body="{ dictType: 'region' }"
              :placeholder="$l('form_placeholder_region') || '请选择货物运抵国'"
              size="mini"
              filterable
              clearable
              style="width:100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_dispatchPort') || '出运港口'">
            <dict-select
              v-model="formData.dispatchPort"
              url="/master/port/select"
              :placeholder="
                $l('form_placeholder_dispatchPort') || '请选择出运港口'
              "
              size="mini"
              filterable
              clearable
              style="width:100%"
            />
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item :label="$l('form_label_whName') || '收获仓库编号'">
            <el-input
              v-model="formData.whName"
              :placeholder="
                $l('form_placeholder_whName') || '请输入收获仓库编号'
              "
              :maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_whAddress') || '仓库地址'">
            <el-input
              v-model="formData.whAddress"
              :placeholder="
                $l('form_placeholder_whAddress') || '请输入仓库地址'
              "
              :maxlength="500"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="mt-3 mb-2 d-flex align-items-center">
      <h6 style="color: #101010" class="m-0">
        {{ $l('form_label_packingScheme') || '大货包装方案' }}
      </h6>
      <el-divider direction="vertical" v-if="!disabled" />
      <b-button
        size="sm"
        variant="outline-success"
        @click="addPacking"
        v-if="!disabled"
      >
        {{ $l('btn_addPacking') || '新增方案' }}
      </b-button>
    </div>
    <el-form
      ref="packingForm"
      class="packing-form"
      v-for="(packing, index) in listPacking"
      :key="index"
      :model="packing"
      :rules="packingRules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_evgPackingScheme') || '对应大货包装方案'"
            prop="evgPackingSchemeCode"
          >
            <dict-select
              v-if="!disabled"
              v-model="packing.evgPackingSchemeCode"
              :selectedLabel.sync="packing.evgPackingSchemeName"
              url="/ecom/evg/packing/scheme/select"
              :body="evgPackingSchemeParams"
              :placeholder="
                $l('form_placeholder_evgPackingScheme') ||
                  '请选择对应大货包装方案'
              "
              size="mini"
              filterable
              clearable
              style="width: 100%"
              @change="packingSchemeChange(packing)"
            >
              <template #default="{options}">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="isDisabled(item)"
                />
              </template>
              <template #empty v-if="!formData.platformCode">
                <p class="el-select-dropdown__empty">
                  {{
                    $l('form_placeholder_evgPackingScheme_platformCode_emp') ||
                      '请先选择渠道'
                  }}
                </p>
              </template>
            </dict-select>
            <el-input
              v-if="disabled"
              v-model="packing.evgPackingSchemeName"
              readonly
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_palletItemNo') || '客户产品ITEM号'"
          >
            <el-input v-model="packing.palletItemNo" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_palletItemName') || '客户产品名称'"
          >
            <el-input v-model="packing.palletItemName" readonly />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="d-flex">
        <el-row :gutter="10" class="flex-grow-1">
          <el-col :span="3">
            <el-form-item :label="$l('form_label_containerName') || '出运箱型'">
              <el-input v-model="packing.containerName" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :label="$l('form_label_inContainerQty') || '装柜入数'"
            >
              <el-input
                :value="
                  `${packing.inContainerQty || '0'} ${
                    packing.v_inContainerUnit
                  }`
                "
                readonly
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :label="$l('form_label_palletLength') || '单托长(cm)'"
            >
              <el-input v-model="packing.palletLength" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item :label="$l('form_label_palletWidth') || '单托宽(cm)'">
              <el-input v-model="packing.palletWidth" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :label="$l('form_label_palletHeight') || '单托高(cm)'"
            >
              <el-input v-model="packing.palletHeight" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :label="$l('form_label_palletGrossWeight') || '单托毛重KGS'"
            >
              <el-input v-model="packing.palletGrossWeight" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :label="$l('form_label_palletNetWeight') || '单托净重KGS'"
            >
              <el-input v-model="packing.palletNetWeight" readonly />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              :label="$l('form_label_palletVolumes') || '单托体积m3'"
            >
              <el-input v-model="packing.palletVolumes" readonly />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="pl-2" v-if="canDelete && !disabled">
          <el-form-item>
            <template #label>
              <div><br /></div>
            </template>
            <el-tooltip
              effect="dark"
              :content="$l('INDEX.btn_tips_del') || '删除'"
              placement="top"
            >
              <i
                class="el-icon-delete text-danger tool-btn"
                @click="deletePacking(index)"
              />
            </el-tooltip>
          </el-form-item>
        </div>
      </div>
    </el-form>

    <SkuTable
      class="mt-3"
      ref="skuTable"
      :disabled="disabled"
      :evgBulkOrderCode="evgBulkOrderCode"
      :listEvgPackingSchemeCode="listEvgPackingSchemeCode"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import SkuTable from '../sku-table'
const initPacking = {
  evgPackingSchemeCode: '',
  evgPackingSchemeName: '',
  palletItemNo: '',
  palletItemName: '',
  containerName: '',
  inContainerQty: '',
  v_inContainerUnit: '',
  palletGrossWeight: '',
  palletNetWeight: '',
  palletVolumes: '',
}
export default {
  mixins: [EditLoading],
  components: { SkuTable },
  props: {
    disabled: { type: Boolean, default: true },
    evgBulkOrderCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {
        salesPersonCode: '',
        salesPersonName: '',
        orderPacking: {},
        regionCode: '',
        regionName: '',
        dispatchPort: '',
        custCode: '',
        custName: '',
        salesCurrencyUnit: 'USD',
      },
      listPacking: [{ ...initPacking }],
      rules: {
        outBillType: [
          {
            required: true,
            message:
              this.$l('form_placeholder_outBillType') || '请选择出单类型',
            trigger: 'change',
          },
        ],
        salesPersonCode: [
          {
            required: true,
            message: this.$l('form_placeholder_salesPerson') || '请选择业务',
            trigger: 'change',
          },
        ],
        merchandiserCode: [
          {
            required: true,
            message: this.$l('form_placeholder_merchandiser') || '请选择跟单',
            trigger: 'change',
          },
        ],
        platformCode: [
          {
            required: true,
            message: this.$l('form_placeholder_platform') || '请选择渠道',
            trigger: 'change',
          },
        ],
        custOrderNo: [
          {
            required: true,
            message:
              this.$l('form_placeholder_custOrderNo') || '请输入客户订单号',
            trigger: 'blur',
          },
        ],
        orderDate: [
          {
            required: true,
            message: this.$l('form_placeholder_orderDate') || '请选择订单日期',
            trigger: 'change',
          },
        ],
        deliveryDate: [
          {
            required: true,
            message:
              this.$l('form_placeholder_deliveryDate') || '请选择交货日期',
            trigger: 'change',
          },
        ],
        beginShippingDate: [
          {
            required: true,
            message:
              this.$l('form_placeholder_beginShippingDate') ||
              '请选择最早发运日期',
            trigger: 'change',
          },
        ],
        endShippingDate: [
          {
            required: true,
            message:
              this.$l('form_placeholder_endShippingDate') ||
              '请选择最晚发运日期',
            trigger: 'change',
          },
        ],
        paymentTerms: [
          {
            required: true,
            message:
              this.$l('form_placeholder_paymentTerms') || '请选择客户付款条件',
            trigger: 'change',
          },
        ],
      },
      packingRules: {
        evgPackingSchemeCode: [
          {
            required: true,
            message:
              this.$l('form_placeholder_evgPackingScheme') ||
              '请选择对应大货包装方案',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    ...mapState('admin/user', { userInfo: 'info' }),
    canDelete() {
      return this.listPacking.length > 1
    },
    evgPackingSchemeParams() {
      const { platformCode, custCode } = this.formData
      return { platformCode: platformCode || 'platformCode', custCode }
    },
    listEvgPackingSchemeCode() {
      const codes = this.listPacking
        .map((item) => item.evgPackingSchemeCode)
        .filter(Boolean)
      return [...new Set(codes || [])]
    },
  },
  watch: {
    userInfo: {
      handler() {
        if (this.amzExpenseCode) return
        if (!this.userInfo) return
        const { userCode, userName, userNameEn } = this.userInfo
        this.formData.salesPersonCode = userCode || ''
        this.formData.salesPersonName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
    this.getPacking()

    if (this.disabled) this.$refs.skuTable.getData()
  },
  methods: {
    async getData() {
      if (!this.evgBulkOrderCode) return
      const data = await this.$api
        .ecomEvgBulkOrderDetailApi({ evgBulkOrderCode: this.evgBulkOrderCode })
        .then((res) => res.body || {})
        .catch(() => ({}))
      const { evgPackingSchemeCode } = data.orderPacking || {}
      this.formData = { ...data, evgPackingSchemeCode }
      this.$emit('loaded', this.formData)
    },
    async getPacking() {
      if (!this.evgBulkOrderCode) return
      const data = await this.$api
        .ecomEvgBulkOrderPackingListApi({
          evgBulkOrderCode: this.evgBulkOrderCode,
        })
        .then((res) => res?.body?.data || [])
        .catch(() => [])
      this.listPacking = data

      if (this.disabled) return
      this.$nextTick(() => this.$refs.skuTable.getData())
    },
    addPacking() {
      this.listPacking.push({ ...initPacking })
    },
    async deletePacking(index) {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_deletePacking') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      this.listPacking.splice(index, 1)

      this.$nextTick(() => this.$refs.skuTable.getData())
    },
    async packingSchemeChange(packing) {
      const { evgPackingSchemeCode } = packing || {}

      const getInfo = async () => {
        if (!evgPackingSchemeCode) return {}
        return await this.$api
          .ecomEvgPackingSchemeDetailApi({ evgPackingSchemeCode })
          .then((res) => res.body || {})
          .catch(() => ({}))
      }
      const data = await getInfo()

      const { regionCode, regionName, dispatchPort } = data
      packing.palletItemNo = data.palletItemNo
      packing.palletItemName = data.palletItemName
      packing.containerName = data.containerName
      packing.inContainerQty = data.inContainerQty
      packing.v_inContainerUnit = data.v_inContainerUnit
      packing.palletGrossWeight = data.palletGrossWeight
      packing.palletNetWeight = data.palletNetWeight
      packing.palletVolumes = data.palletVolumes
      packing.palletLength = data.palletLength
      packing.palletWidth = data.palletWidth
      packing.palletHeight = data.palletHeight

      this.formData.regionCode = regionCode || this.formData.regionCode
      this.formData.regionName = regionName || this.formData.regionName
      this.formData.dispatchPort = dispatchPort || this.formData.dispatchPort

      this.$nextTick(() => this.$refs.skuTable.getData())
    },
    isDisabled({ value }) {
      return this.listEvgPackingSchemeCode.includes(value)
    },
    async save() {
      const result = await validate.formValidate([
        this.$refs.form,
        ...(this.$refs.packingForm || []),
      ])
      if (!result) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomEvgBulkOrderSaveApi({
          ...this.formData,
          listEvgPackingSchemeCode: this.listEvgPackingSchemeCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      if (this.evgBulkOrderCode) return this.getData()

      const { evgBulkOrderCode, evgBulkOrderNo } = body
      this.$router.replace({
        name: 'ecom-evgBiz-evgBulkOrder-detail',
        params: { evgBulkOrderCode, pageType: 'edit' },
        query: { evgBulkOrderNo },
      })
    },
    async platformChange(platformCode) {
      this.listPacking = [{ ...initPacking }]

      if (!platformCode) return

      const res = await this.$api
        .ecomEvgPlatformDetailApi({ platformCode })
        .catch(() => null)
      const data = res?.body
      this.formData.custCode = data?.custCode || ''
      this.formData.custName = data?.custName || ''
    },
  },
}
</script>
<style lang="scss" scoped>
.packing-form {
  background-color: #f4f6f9;
  padding: 16px;
  padding-bottom: 6px;
  border-radius: 5px;
  margin-bottom: 16px;
  .tool-btn {
    font-size: 22px;
  }
}
::v-deep {
  .packing-form {
    .el-input.is-disabled .el-input__inner,
    .el-textarea.is-disabled .el-textarea__inner {
      color: #606266 !important;
      background-color: #fff !important;
      border: 1px solid #dcdfe6 !important;
    }
  }
}
</style>
